module.exports = __webpack_public_path__ + "static/img/modern.aad19d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modern.svg
// module id = 603
// module chunks = 1